import './App.css';


import Layout from './Layout';

import CryptoList from './CryptoList';
import CryptoDetail from './CryptoDetail';

import FearAndGreed from './FearAndGreed';
import MacroDominanceScreen from './features/macro/MacroDominanceScreen';
import CurrencyList from './CurrencyList';
import CurrencyDetail from './CurrencyDetail';
import CryptoHeatmap from './components/CryptoHeatmap';
import BtcDominanceDetail from './BtcDominanceDetail';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';

// ...existing code...
import Contact from './Contact';
import UnifiedPortfolioPage from './UnifiedPortfolioPage';
import About from './About';
import React, { useState, useEffect } from 'react';
import DashboardUltraPremium from './DashboardUltraPremium';
import MarketIntelligencePage from './pages/market-intelligence/MarketIntelligencePage';
import AssetScannerPage from './pages/asset-scanner/AssetScannerPage';
import PatternScannerDetailPage from './pages/pattern-scanner/PatternScannerDetailPage';
import PatternScannerOverviewPage from './pages/pattern-scanner/PatternScannerOverviewPage';
import HomePage from './pages/home/HomePage';
import LoginPage from './pages/auth/LoginPage';
import RequireLoginRoute from './components/auth/RequireLoginRoute';
import ComingSoonPage from './pages/coming-soon/ComingSoonPage';
import { fetchPublicConfig } from './api/publicConfig';
// ...existing code...
import AdminPage from './pages/admin/AdminPage';
import ConnectionsPage from './ConnectionsPage';
import ManualTradingPage from './pages/trading/ManualTradingPage';
import BlofinManualOrderPage from './pages/trading/BlofinManualOrderPage';
import CryptoOrdersAdminPage from './pages/trading/CryptoOrdersAdminPage';
import TradingStatsPage from './pages/trading/TradingStatsPage';

function persistStoredUser(user) {
  try {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  } catch {
    // Ignore storage failures and keep the UI usable.
  }
}

function loadStoredUser() {
  try {
    const rawUser = localStorage.getItem('user');
    if (!rawUser) {
      return null;
    }

    const parsedUser = JSON.parse(rawUser);
    return normalizeAuthenticatedUser(parsedUser);
  } catch {
    return null;
  }
}

function normalizeAuthenticatedUser(payload) {
  if (!payload || !payload.login) {
    return null;
  }
  return {
    login: payload.login,
    name: payload.login,
    role: payload.role || 'USER',
  };
}

// Wrapper pour injecter les cryptos dans CryptoHeatmap
function CryptoHeatmapWrapper() {
  const [cryptos, setCryptos] = React.useState([]);
  React.useEffect(() => {
    fetch('/api/cryptos')
      .then(res => res.json())
      .then(data => {
        let arr = Array.isArray(data.content) ? data.content : Array.isArray(data) ? data : [];
        // On ne garde que les champs nÃ©cessaires
        arr = arr.map(c => ({
          id: c.id,
          symbol: c.symbol,
          name: c.name,
          marketCap: c.marketCap ?? c.marketcap ?? 0,
          priceChange24h: c.priceChange24h ?? 0,
          priceChangePercentage24h: c.priceChangePercentage24h ?? 0
        }));
        setCryptos(arr);
      });
  }, []);
  return <CryptoHeatmap cryptos={cryptos} />;
}


export function AppRoutes() {
  // Debug log removed: [App] Composant App montÃ©, rendu principal
  const [currencyRefresh, setCurrencyRefresh] = useState(0);
  const [publicConfig, setPublicConfig] = useState({ comingSoon: false });
  useEffect(() => {
    fetchPublicConfig().then(cfg => setPublicConfig(cfg));
  }, []);
  const [user, setUser] = useState(() => loadStoredUser());
  const [authResolved, setAuthResolved] = useState(() => Boolean(loadStoredUser()));

  useEffect(() => {
    let cancelled = false;

    const syncAuthenticatedUser = async () => {
      const fallbackUser = loadStoredUser();

      try {
        const response = await fetch('/api/users/me', { credentials: 'include' });
        if (!response.ok) {
          if (response.status === 401 || response.status === 403) {
            persistStoredUser(null);
            if (!cancelled) {
              setUser(null);
            }
          } else if (!cancelled) {
            setUser(fallbackUser);
          }
          return;
        }

        const payload = await response.json();
        const nextUser = normalizeAuthenticatedUser(payload);
        persistStoredUser(nextUser);
        if (!cancelled) {
          setUser(nextUser);
        }
      } catch {
        if (!cancelled) {
          setUser(fallbackUser);
        }
      } finally {
        if (!cancelled) {
          setAuthResolved(true);
        }
      }
    };

    void syncAuthenticatedUser();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (user === undefined) {
      return;
    }
    persistStoredUser(user);
  }, [user]);

  // Initialisation automatique de window.cryptoTable
  useEffect(() => {
    if (typeof window !== 'undefined' && !window.cryptoTable) {
      const stored = localStorage.getItem('ecotoneai_cryptoTable');
      if (stored) {
        try {
          window.cryptoTable = JSON.parse(stored);
          // Debug log removed: [App] window.cryptoTable initialisÃ©e depuis localStorage
        } catch (e) {
          window.cryptoTable = [];
        }
      } else {
        window.cryptoTable = [];
        // Debug log removed: [App] window.cryptoTable initialisÃ©e vide
      }
    }
  }, []);

  const handleCurrencyChange = () => setCurrencyRefresh(r => r + 1);
  const handleThemeChange = (value) => {
    document.cookie = `theme=${value};path=/;max-age=31536000`;
    localStorage.setItem('ecotoneai_theme', value);
    document.documentElement.setAttribute('data-theme', value === 'system' ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light') : value);
  };
  useEffect(() => {
    // Au montage, applique le thÃ¨me depuis localStorage si prÃ©sent
    const storedTheme = localStorage.getItem('ecotoneai_theme');
    if (storedTheme) {
      document.documentElement.setAttribute('data-theme', storedTheme === 'system' ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light') : storedTheme);
    }
  }, []);

  const location = useLocation();
  const showComingSoonRoot = publicConfig.comingSoon && location.pathname === '/';

  // Default-deny: a screen is private unless it is explicitly declared public below.
  // Every entry in `authenticatedRoutes` is wrapped by the single central guard, so a
  // newly added application screen is authenticated by default. Unknown routes are also
  // guarded by the catch-all, so adding a page cannot silently make it anonymous.
  const guard = (element) => (
    <RequireLoginRoute user={user} authResolved={authResolved}>{element}</RequireLoginRoute>
  );

  const adminGuard = (element) => (
    <RequireLoginRoute user={user} authResolved={authResolved} requiredRole="ADMIN">{element}</RequireLoginRoute>
  );

  const authenticatedRoutes = [
    { path: '/cryptos', element: <CryptoList key={currencyRefresh} /> },
    { path: '/cryptos/heatmap', element: <CryptoHeatmapWrapper /> },
    { path: '/cryptos/:id', element: <CryptoDetail key={currencyRefresh} /> },
    { path: '/fear-and-greed', element: <FearAndGreed /> },
    { path: '/btc-dominance', element: <BtcDominanceDetail /> },
    { path: '/currencies', element: <CurrencyList /> },
    { path: '/currencies/:id', element: <CurrencyDetail /> },
    { path: '/unified-portfolio', element: <UnifiedPortfolioPage /> },
    { path: '/dashboard', element: <DashboardUltraPremium /> },
    { path: '/admin/*', element: <AdminPage /> },
    { path: '/contact', element: <Contact /> },
    { path: '/about', element: <About /> },
    { path: '/macro-dominance', element: <MacroDominanceScreen /> },
    { path: '/market', element: <MarketIntelligencePage /> },
    { path: '/asset-scanner', element: <AssetScannerPage /> },
    { path: '/scanner', element: <PatternScannerOverviewPage user={authResolved ? user || null : null} authResolved={authResolved} /> },
    { path: '/scanner/:symbol', element: <PatternScannerDetailPage user={authResolved ? user || null : null} authResolved={authResolved} /> },
    { path: '/pattern-scanner', element: <Navigate to="/scanner" replace /> },
    { path: '/connections', element: <ConnectionsPage /> },
    { path: '/trading/manual', element: <ManualTradingPage /> },
    { path: '/trading/orders', element: <CryptoOrdersAdminPage />, adminOnly: true },
    { path: '/trading/blofin', element: <BlofinManualOrderPage />, adminOnly: true },
    { path: '/trading/stats', element: <TradingStatsPage />, adminOnly: true },
  ];

  const routes = (
    <Routes>
      {/* PUBLIC: landing page and authentication only. Access must be opted into explicitly. */}
      <Route path="/" element={publicConfig.comingSoon ? <ComingSoonPage /> : <HomePage />} />
      <Route path="/login" element={<LoginPage user={authResolved ? user || null : null} setUser={setUser} />} />

      {/* AUTHENTICATED (default): every application screen. */}
      {authenticatedRoutes.map(({ path, element, adminOnly }) => (
        <Route key={path} path={path} element={adminOnly ? adminGuard(element) : guard(element)} />
      ))}

      {/* Unknown/new routes are private by default. */}
      <Route path="*" element={guard(<Navigate to="/" replace />)} />
    </Routes>
  );

  if (showComingSoonRoot) {
    return routes;
  }

  if (authResolved && user?.login) {
    return (
      <Layout headerProps={{ onCurrencyChange: handleCurrencyChange, user: authResolved ? user || null : null, setUser, onThemeChange: handleThemeChange }}>
        {/* Debug log removed: [App] Avant <Routes> rendu */}
        {routes}
      </Layout>
    );
  }

  return routes;
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
